import axios from 'axios';

const addNoOption = (data) => {
  return data;
};

const addDefault = (data) => {
  return data.concat({ default: true });
};

const SmartOrganisationSearchService = {
  getAbnAcnDetail: (authorization, endpoint, term) =>
    axios
      .get(`${endpoint}/getOrganisationByAbn/${term}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authorization ? `Bearer ${authorization}` : undefined
        }
      })
      .then((response) => response?.data)
      .catch((error) => {
        console.error(error);
        return undefined;
      }),
  getYincDetail: (authorization, endpoint, term, name) =>
    axios
      .post(
        `${endpoint}/GetOrganisationByYincOther`,
        {
          YincOther: term,
          OrganisationName: name
        },
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authorization ? `Bearer ${authorization}` : undefined
          }
        }
      )
      .then((response) => response?.data)
      .catch((error) => {
        console.error(error);
        return undefined;
      }),
  searchAbnAcn: (authorization, endpoint, term, hasManualLookup) =>
    axios
      .get(`${endpoint}/searchorganisation?registrationType=AbnAcn&searchString=${term}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authorization ? `Bearer ${authorization}` : undefined
        }
      })
      .then((response) => addNoOption(response?.data))
      .then((data) => (hasManualLookup ? addDefault(data) : data))
      .catch((error) => {
        console.error(error);
        return [];
      }),
  searchYinc: (authorization, endpoint, term, hasManualLookup) =>
    axios
      .get(`${endpoint}/searchorganisation?registrationType=yincother&searchString=${term}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authorization ? `Bearer ${authorization}` : undefined
        }
      })
      .then((response) => response?.data)
      .then((data) => (hasManualLookup ? addDefault(data) : data))
      .catch((error) => {
        console.error(error);
        return [];
      })
};

export default SmartOrganisationSearchService;
